import AddClientForm from 'modules/Forms/Agency/ClientRequest'
import React from 'react'

const AddClient = () => <AddClientForm />

export default AddClient
